/** 目录页水平边距（列表 / 详情共用，尽量贴边） */
export const CATALOG_PAGE_GUTTER_CLASS = 'w-full px-2 sm:px-3'

/** 全宽列表页外边距（尽量贴边，去掉两侧大留白） */
export const CATALOG_LIST_PAGE_CLASS = `${CATALOG_PAGE_GUTTER_CLASS} py-4`

/** 目录详情页：与列表同宽，略增纵向留白 */
export const CATALOG_DETAIL_PAGE_CLASS = `${CATALOG_PAGE_GUTTER_CLASS} py-5 sm:py-6 lg:py-8`

/** 详情页主栏 + 操作侧栏；宽屏侧栏略放宽，主图吃剩余宽度 */
export const CATALOG_DETAIL_LAYOUT_CLASS =
  'grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(17.5rem,22rem)] lg:items-start xl:gap-8 2xl:grid-cols-[minmax(0,1fr)_minmax(18.75rem,24rem)]'

/** 详情页主栏 + 侧栏：固定 65:35（学习 / 作品 / 赛事 / 交易 / 任务） */
export const CATALOG_DETAIL_PLAYER_LAYOUT_CLASS =
  'grid gap-6 lg:grid-cols-[minmax(0,13fr)_minmax(20rem,7fr)] lg:items-start xl:gap-8'

/** 详情页左栏内嵌卡片：一行最多三张，避免 65% 主栏里挤成 4–5 列 */
export const CATALOG_DETAIL_CARD_GRID_CLASS =
  'grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-3 xl:gap-3.5'

/**
 * 详情页封面 / 成片：固定 16:9。
 * 只写 max-h 会截高度、不缩宽度，框被拉成超宽，16:9 成片 object-contain 两侧留黑边。
 * 超高屏用 max-h 时同步用 max-w 锁比例。
 */
export const CATALOG_DETAIL_MEDIA_CLASS =
  'relative mx-auto aspect-video h-auto w-full max-h-[min(68vh,52rem)] max-w-[min(100%,calc(min(68vh,52rem)*16/9))] overflow-hidden'

/** 目录列表统一网格：大屏固定 5 列 */
export const CATALOG_LIST_GRID_CLASS =
  'grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 lg:gap-2.5 xl:gap-3'

/** 账户反馈 / 充值等侧栏布局：一行三列 */
export const ACCOUNT_CARD_GRID_CLASS =
  'grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3'

/** @deprecated 使用 ACCOUNT_CARD_GRID_CLASS */
export const FEEDBACK_LIST_GRID_CLASS = ACCOUNT_CARD_GRID_CLASS

/**
 * 目录卡片封面槽统一比例（16:10）。
 * 有封面时：固定槽 + 模糊衬底 + 居中 object-contain（见 CatalogListCardMedia）。
 * 无封面 / 骨架屏：同比例占位。
 */
export const CATALOG_LIST_COVER_FALLBACK_ASPECT = 'aspect-[16/10]' as const

/** @deprecated 使用 CATALOG_LIST_COVER_FALLBACK_ASPECT；封面已改为自适应 */
export const CATALOG_LIST_COVER_ASPECT = CATALOG_LIST_COVER_FALLBACK_ASPECT

/** 骨架屏正文占位高度（约封面一半视觉） */
export const CATALOG_LIST_BODY_FALLBACK_ASPECT = 'aspect-[16/5]' as const

/** @deprecated 使用 CATALOG_LIST_BODY_FALLBACK_ASPECT；正文已改为内容撑开 */
export const CATALOG_LIST_BODY_ASPECT = CATALOG_LIST_BODY_FALLBACK_ASPECT
